export const features = [
  {
    icon: 'ri-dashboard-line',
    title: '数据看板',
    description: '实时可视化数据展示，关键指标一目了然，支持自定义图表配置和智能预警提醒。',
  },
  {
    icon: 'ri-brain-line',
    title: '智能分析',
    description: '基于AI技术的深度数据分析引擎，自动识别趋势、检测异常，提供决策建议。',
  },
  {
    icon: 'ri-flow-chart',
    title: '自动化工作流',
    description: '拖拽式工作流配置，让重复操作自动化执行，大幅提升工作效率。',
  },
  {
    icon: 'ri-team-line',
    title: '团队协作',
    description: '实时多人协作编辑，评论讨论系统，灵活的权限管理，让团队协作无缝衔接。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全防护',
    description: '企业级数据安全保障，支持双重验证、数据加密和全面的审计日志。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端同步',
    description: '桌面端与移动端完美同步，支持离线使用，随时随地访问您的数据和工作内容。',
  },
];

export const userReviews = [
  {
    name: '张明',
    role: '产品经理',
    company: '某互联网科技公司',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20photo%20of%20Chinese%20male%20professional%20in%20his%2030s%2C%20warm%20lighting%2C%20simple%20neutral%20background%2C%20clean%20corporate%20headshot%20style&width=100&height=100&seq=avatar-01&orientation=squarish',
    content: '使用91c半年，我们的数据决策效率得到了显著提升。智能分析引擎给出的洞察经常超出我的预期，强烈推荐！',
    rating: 5,
  },
  {
    name: '李婷',
    role: '自由设计师',
    company: '独立工作者',
    avatar: 'https://readdy.ai/api/search-image?query=Elegant%20portrait%20photo%20of%20Chinese%20female%20professional%20in%20her%2020s%2C%20soft%20natural%20lighting%2C%20minimal%20cream%20background%2C%20warm%20friendly%20expression&width=100&height=100&seq=avatar-02&orientation=squarish',
    content: '作为自由职业者，91c让我能够像大公司一样专业地管理项目和数据。移动端体验也很棒，随时随地都能处理工作。',
    rating: 5,
  },
  {
    name: '王磊',
    role: '技术总监',
    company: '某SaaS创业公司',
    avatar: 'https://readdy.ai/api/search-image?query=Confident%20portrait%20photo%20of%20Chinese%20male%20tech%20professional%20in%20his%2030s%2C%20modern%20office%20background%2C%20natural%20light%2C%20contemporary%20headshot&width=100&height=100&seq=avatar-03&orientation=squarish',
    content: '91c的API接口设计非常规范，我们仅用两周就完成了全平台集成。自动化工作流功能帮我们节省了大量人力成本。',
    rating: 5,
  },
  {
    name: '陈雪',
    role: '运营主管',
    company: '某电商平台',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20Chinese%20female%20businesswoman%20in%20her%2030s%2C%20warm%20studio%20lighting%2C%20soft%20beige%20background%2C%20modern%20headshot&width=100&height=100&seq=avatar-04&orientation=squarish',
    content: '数据看板功能是我们团队每天必用的工具，自定义报表让周报和月报的制作从几小时缩短到了几分钟。',
    rating: 4,
  },
  {
    name: '刘洋',
    role: '高校教师',
    company: '某985高校',
    avatar: 'https://readdy.ai/api/search-image?query=Nice%20portrait%20of%20Chinese%20male%20educator%20in%20his%2040s%2C%20academic%20setting%20with%20books%2C%20soft%20natural%20light%2C%20friendly%20smile&width=100&height=100&seq=avatar-05&orientation=squarish',
    content: '在教学中引入91c后，学生们对数据分析的兴趣明显提高了。操作界面直观，零基础的学生也能快速上手。',
    rating: 5,
  },
];

export const stats = [
  { value: '50,000+', label: '活跃用户' },
  { value: '99.9%', label: '服务可用率' },
  { value: '4.8/5', label: '用户满意度' },
  { value: '200+', label: '企业客户' },
];